/*************************************
AB - QUE INCLUYE KIT
Auto add free gift when cart contains a "Kit" product (UpCart)
**************************************/
(function () {
  var dataEl = document.getElementById('kit-gift-upcart-data');
  if (!dataEl) {
    return;
  }

  var giftData;
  try {
    giftData = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }

  var GIFT_VARIANT_ID = giftData.variantId;
  if (!GIFT_VARIANT_ID) {
    return;
  }

  // While true, incoming cart events are ignored. This is set BEFORE we
  // make our own /cart/add.js call and only cleared after a cooldown, so
  // the cart-updated event our own call triggers never causes us to react
  // to ourselves (which caused a runaway loop: add gift -> cart-updated
  // fires -> check runs -> add gift again -> ...).
  var isMutating = false;
  var MUTATION_COOLDOWN_MS = 1500;

  var isChecking = false;
  var debounceTimer = null;
  var DEBOUNCE_MS = 600;

  function cartHasKit(cart) {
    return cart.items.some(function (item) {
      if (item.variant_id === GIFT_VARIANT_ID) {
        return false;
      }
      return typeof item.title === 'string' && item.title.toLowerCase().indexOf('kit') !== -1;
    });
  }

  function cartHasGift(cart) {
    return cart.items.some(function (item) {
      return item.variant_id === GIFT_VARIANT_ID;
    });
  }

  function fetchCart() {
    return fetch('/cart.js').then(function (response) {
      return response.json();
    });
  }

  function addGift() {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{ id: GIFT_VARIANT_ID, quantity: 1 }]
      })
    });
  }

  function endMutationAfterCooldown() {
    window.setTimeout(function () {
      isMutating = false;
    }, MUTATION_COOLDOWN_MS);
  }

  // Reads the cart fresh from Shopify and adds the gift if the cart has a
  // kit product and doesn't have the gift yet. Never removes it — removal
  // is manual from now on.
  function checkAndSync() {
    if (isMutating || isChecking) {
      return;
    }
    isChecking = true;

    fetchCart()
      .then(function (cart) {
        var hasKit = cartHasKit(cart);
        var hasGift = cartHasGift(cart);

        if (hasKit && !hasGift) {
          isMutating = true;
          return addGift()
            .then(function () {
              if (typeof window.upcartRefreshCart === 'function') {
                return window.upcartRefreshCart();
              }
            })
            .finally(endMutationAfterCooldown);
        }
        // Already in the correct state, or gift removal is now manual: do nothing.
      })
      .catch(function () {})
      .finally(function () {
        isChecking = false;
      });
  }

  // Waits for the cart to stop changing before checking, so we never
  // race UpCart's own in-flight add/remove request.
  function scheduleCheck() {
    if (isMutating) {
      return;
    }
    if (debounceTimer) {
      window.clearTimeout(debounceTimer);
    }
    debounceTimer = window.setTimeout(function () {
      debounceTimer = null;
      checkAndSync();
    }, DEBOUNCE_MS);
  }

  function init() {
    if (
      typeof window.upcartSubscribeCartUpdated !== 'function' ||
      typeof window.upcartSubscribeCartLoaded !== 'function' ||
      typeof window.upcartSubscribeItemRemoved !== 'function'
    ) {
      window.setTimeout(init, 200);
      return;
    }

    window.upcartSubscribeCartLoaded(scheduleCheck);
    window.upcartSubscribeCartUpdated(scheduleCheck);
    window.upcartSubscribeItemRemoved(scheduleCheck);

    scheduleCheck();
  }

  init();
})();
